/**
 * @desc 退货分页查询
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.platDataFlow.reportPage.postReturnPage.Params, options?: any) {
  return updateResponse(
    http(URL + `/reportPage/returnPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
